module.exports = __webpack_public_path__ + "img/icon_qr.48d198c7.svg";